import { isClientSessionTokenValid, refreshClientSessionToken, } from "../../utils/dwclient/dwclientutils";
import { deleteClientId } from "../../utils/dwclient/localstorage/clientIdStorage";
import { deleteClientSessionToken, } from "../../utils/dwclient/localstorage/clientSessionTokenStorage";
import { deleteJwt } from "../../utils/dwclient/localstorage/jwtStorage";
import { deleteUserShares } from "../../utils/dwclient/localstorage/userShareStorage";
import { createAuthToken } from "./createAuthToken";
import { recoverMpcWallet } from "./recoverMpcWallet";
export async function createAuthTokenProcess(provider, walletAddress, mpcWalletData) {
    const clientId = mpcWalletData.clientId;
    let clientSessionToken = mpcWalletData.clientSessionToken;
    const userSharesString = mpcWalletData.userSharesString;
    const myApiVersion = process.env.API_VERSION || "1.0";
    if (clientId !== null && userSharesString !== null) {
        //console.log("onboarding:create auth toekn");
        if (clientSessionToken === null || !(await isClientSessionTokenValid(clientSessionToken))) {
            const clientSessionTokenHolder = await refreshClientSessionToken(provider, walletAddress, clientId, myApiVersion);
            clientSessionToken = clientSessionTokenHolder.clientSessionToken;
            mpcWalletData.clientSessionToken = clientSessionToken;
        }
        const jwt = await createAuthToken(clientId, clientSessionToken, userSharesString); // may throw exception
        if (jwt !== undefined) {
            mpcWalletData.authToken = jwt;
            //console.log("JWT", jwt);
            return mpcWalletData;
        }
        // Never leave a recovery token in the auth field when the backend did not
        // issue a dashboard JWT.
        mpcWalletData.authToken = null;
        // clientSessionToken refresh failed because there can be not CST created
        /*    let userShares: MpcWalletUserShares;
        try {
          userShares = await recoverMpcWallet(walletAddress, clientId);
        } catch (error: any) {
          if (isRealRecoverMpcWalletError(error)) {
            throw error;
          }
        }*/
    }
    return mpcWalletData;
    /*  const mpcWalletData: CreateMpcWalletResponse = await createMpcWallet(walletAddress);
    const jwt = mpcWalletData.authToken;
    storeJwt(jwt);
    return jwt;*/
}
export async function recoverMpcWalletProcess(walletAddress, mpcWalletData, wallet) {
    //console.log("onboarding:recover");
    try {
        //console.log("clientId", mpcWalletData.clientId);
        mpcWalletData = await recoverMpcWallet(walletAddress, wallet);
        // TODO
        return mpcWalletData;
    }
    catch (error) {
        if (isRealRecoverMpcWalletError(error)) {
            throw error;
        }
        return mpcWalletData;
    }
}
export function deleteMpcData() {
    //console.log("deleteMpcData");
    deleteClientId();
    deleteClientSessionToken();
    deleteUserShares();
    deleteJwt();
    localStorage.removeItem("selectedWalletRdns");
    localStorage.removeItem("prevWalletRdns");
}
function isRealRecoverMpcWalletError(error) {
    return true;
}
